import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 17331 13433"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#2b2a29}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="m5960 9533 1489 1355c668-609 1760-609 2430 0l1492-1355c-1492-1356-3922-1356-5411 0z"
        className="fil0"
      />
      <path
        d="m3973 7446 1490 1353c1765-1600 4638-1603 6400 0l1494-1353c-2588-2355-6798-2352-9384 0z"
        className="fil0"
      />
      <path
        d="m1984 5377 1489 1356c2867-2599 7518-2601 10380 0l1490-1356c-3684-3346-9677-3346-13359 0z"
        className="fil0"
      />
      <path
        d="m0 3258 1487 1353c3959-3597 10393-3597 14353 0l1491-1353C12550-1086 4776-1086 0 3258zM8662 11236c-606 0-1096 491-1096 1097 0 609 490 1100 1096 1100 608 0 1103-491 1103-1100 0-606-495-1097-1103-1097z"
        className="fil0"
      />
    </g>
  </svg>
)
export default SvgComponent
